export const updateDeal = function(cartProduct, callback) {
  if (cartProduct.removePermanentDeal) {
    var q = $http({
      method: 'DELETE',
      url: '/api/retailer/deal_notes/' + cartProduct.permanent_deal_notes.id
    })
    $http({
      method: 'PUT',
      url: '/api/retailer/cart_products/' + cartProduct.id,
      data: { cart_product: {deal_notes: '' } }
    })
  } else if (cartProduct.permanentDeal) {
    if (cartProduct.product_id) {
      var pid = cartProduct.product_id;
      var cpid = cartProduct.id;
    } else {
      var pid = cartProduct.id;
      var cpid = null;
    }
    var q = $http({
      method: 'POST',
      url: '/api/retailer/deal_notes/',
      data: { deal_note: {
        inventory_id: cartProduct.inventory_id,
        product_id: pid,
        notes: cartProduct.deal_notes,
        order_id: cartProduct.order_id,
        cart_product_id: cpid
      } }
    });
  } else {
    var q = $http({
      method: 'PUT',
      url: '/api/retailer/cart_products/' + cartProduct.id,
      data: { cart_product: {deal_notes: cartProduct.deal_notes } }
    })
  }
  q.then(function success(res) {
    if(callback) callback(null, res.data);
  }, function error(res) {
    if(callback) callback(res.data, null);
  });
};

var service = function($http) {
  return {
    updateDeal
  }
};
service.$inject = ['$http'];
tiz.service('DealNote', service);
export default service;
